import { useEffect, useRef } from "react";

export const useAutoFocus = <T extends HTMLElement = HTMLInputElement>(
    shouldFocus: boolean = true
): React.RefObject<T | null> => {
    const elementRef = useRef<T>(null);

    useEffect(() => {
        if (shouldFocus && elementRef.current) {
            elementRef.current.focus();
        }
    }, [shouldFocus]);

    return elementRef;
};
